import { defineComponent as _defineComponent } from 'vue'
import IconButton from './base/IconButton.vue';
import { IconButtonLayout } from '../../constants/room';
import LanguageIcon from './icons/LanguageIcon.vue';
import { useBasicStore } from '../../stores/basic';
import i18n from '../../locales/index';
import { computed } from 'vue';
import { roomService } from '../../services';


export default /*#__PURE__*/_defineComponent({
  __name: 'Language',
  setup(__props) {

const basicStore = useBasicStore();

const title = computed(() =>
  basicStore.lang === 'en-US' ? 'English' : '中文'
);
const languageConfig = roomService.getComponentConfig('Language');

const handleChange = () => {
  roomService.setLanguage(
    i18n.global.locale.value === 'en-US' ? 'zh-CN' : 'en-US'
  );
};

return { __sfc: true,basicStore, title, languageConfig, handleChange, IconButton, IconButtonLayout, LanguageIcon }
}

})